import { createSlice } from "@reduxjs/toolkit";
import { logOut } from "./auth";

const initialState = [];

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessages: (state, { payload }) => {
      return payload;
    },
    updateMessage: (state, { payload }) => {
      return state.map((message) =>
        message.id === payload.id ? payload : message
      );
    },
    deleteMessage: (state, { payload }) => {
      return state.filter((message) => message.id !== payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logOut, () => {
      return [];
    });
  },
});

export const { setMessages, updateMessage, deleteMessage } =
  messageSlice.actions;

export default messageSlice.reducer;
